import Vue from 'vue'
import Vuex from 'vuex'
import apiTest from './modules/apiTest'
import auth from './modules/auth'
import profile from './modules/profile'


Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    apiTest,
    auth,
    profile
  }
})
